module.exports = __webpack_public_path__ + "static/media/SIG3.99f59ba2.png";